'use strict';

angular.module('far.mountains')
    .controller('MountainRouteAddController', function ($scope, $log, $http, $window, mountainRouteForm, mountainRoutes, $sce, showModalMessage) {
        var vm = {
            progress: true,
            mountainRouteModel: mountainRouteForm,
            getMountainRoute: getMountainRoute,
            submit: submit,
            alerts: [],
            getDocumentUrl: getDocumentUrl,
            closeAlert: function (index) {
                vm.alerts.splice(index, 1);
            }
        };

        vm.mountainRouteModel.$fields.description.options.class = 'form__item';
        vm.mountainRouteModel.$fields.mountain_peak.uiSelectOptions.onSelect = function(item, model, options) {
            if (item) { vm.mountainRoute.mountain_peaks[options.index] = item; }
        };
        vm.mountainRouteModel.$fields.routeType.options.class = 'form__item form__item_select width-200 margin_r_20';
        vm.mountainRouteModel.$fields.routeComplexity.options.class = 'form__item form__item_select width-200 margin_r_20';
        vm.mountainRouteModel.$fields.routeUser.options.class = 'form__ui-select width-340';
        vm.mountainRouteModel.$fields.routeUser.uiSelectOptions.onSelect = function (item) {
            if (item) { vm.mountainRoute.user = item; }
        };
         vm.mountainRouteModel.$fields.newRouteUserFirstName.options.class = 'form__item  width-200 margin_r_20';
                 vm.mountainRouteModel.$fields.newRouteUserLastName.options.class = 'form__item  width-200 margin_r_20';

        vm.mountainRouteModel.$fields.slidesFiles.uploader.onSuccessItem = function (item, response) {
            vm.mountainRoute.slides_files.push(response);
        };
        vm.mountainRouteModel.$fields.documentsFiles.uploader.removeFromQueue = function (value) {
            var index = this.getIndexOfItem(value);
            var item = this.queue[index];

            if (item.isUploading) {
                item.cancel();
            } else {
                vm.documents_files.splice(index, 1);
            }

            this.queue.splice(index, 1);
            item._destroy();

            this.progress = this._getTotalProgress();
        };

        function getDocumentUrl(file_id) {
            return Routing.generate('api_upload_get_file', {fileStorage: file_id});
        }

        function getMountainRoute() {
            if (arguments.length == 0) {
                vm.mountainRoute = mountainRoutes.new({
                    mountain_peaks: [],
                    slides_files: [],
                    documents_files: []
                });
                vm.mountainRoute.mountain_peaks = [undefined];
                vm.progress = false;
            } else {
                vm.mountainRoute = mountainRoutes.get(arguments[0], function () {
                    if (vm.mountainRoute.mountain_peaks.length == 0) {
                        vm.mountainRoute.mountain_peaks.push();
                    }
                    vm.progress = false;
                });
            }
        }

        function submit() {
            console.log(vm.mountainRoute);

            vm.mountainRoute.documents_files = vm.mountainRoute.documents_files.concat(
                vm.documents_files
                    .filter(function (document) {
                        return document.isUploaded;
                    })
                    .map(function (document) {
                        return document.serverData;
                    })
            );
            vm.mountainRouteModel.$fields.documentsFiles.uploader.clearQueue();

            vm.mountainRoute.slides_files = vm.mountainRoute.slides_files.map(function(slide, index) {
                slide.sort = index + 1;
                return slide;
            });
            if(!vm.mountainRoute.user)
                vm.mountainRoute.user=0;

            vm.mountainRoute.save()
                .then(function () {
                    var message = $sce.trustAsHtml('Маршрут успешно сохранен');
                    var modalInstance = showModalMessage(message);
                    modalInstance.result
                        .then(function() {
                            $window.location.href = Routing.generate('mountains_routes_by_peak');
                        }, function() {
                            $window.location.href = Routing.generate('mountains_routes_by_peak');
                        });
                })
                .catch(function (response) {
                    $log.error(response);
                    var message = 'Возникла проблема при сохранении маршрута. Попробуйте позже.';
                    var modalInstance = showModalMessage(message);
                    modalInstance.result
                        .then(function() {
                            $window.location.href = Routing.generate('mountains_routes_by_peak');
                        }, function() {
                            $window.location.href = Routing.generate('mountains_routes_by_peak');
                        });
                });
        }

        return vm;
    });